/**
 * StickyPageHeader: E3: the page's OWN header block (title, status, toolbar),
 * pinned while the content scrolls under it. Not the table column header row.
 *
 * The scrolling ancestor is `<main className="flex-1 overflow-y-auto">` in
 * AppShell; nothing in between sets `overflow`, so `top-0` pins to the top of the
 * content area. The solid background is required or rows show through.
 *
 * Consumers pass their own negative-margin/padding pair (e.g. `-mx-6 px-6` in a
 * `px-6` page) so the pinned block covers the gutters; paddings differ per screen.
 * Kommunikation and Brok scroll internally, so their headers already never move.
 */

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export function StickyPageHeader({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cn('sticky top-0 z-20 bg-background', className)}>{children}</div>
  );
}
